import { iframeResize } from 'iframe-resizer';

iframeResize({ })
